import type { UpgradePlanPromotion } from '../../repositories/account-repo/schemas/upgrade-plan-promotion.zod';

export class UpgradePlanPromotionVO {
  constructor(private apiResponse: UpgradePlanPromotion) {}

  public getRecommended3PlPlanGroupId(): number | undefined {
    return this.apiResponse.recommended3PlPlanGroupId ?? this.apiResponse.recommendedPlanGroupId;
  }

  public getRecommended3PlPlanId(): number | undefined {
    return this.apiResponse.recommended3PlPlanId ?? this.apiResponse.recommendedPlanId;
  }

  public hasRecommended3Pl(): boolean {
    return this.getRecommended3PlPlanGroupId() != null && this.getRecommended3PlPlanId() != null;
  }
}
